import * as Api from '@/helpers/restApi'

export default {
  state: {
    ShowGroupLearningModal: false,
    ShowMediaUploader: false,
    EventsList: null,
    GroupeInfo: null,
    GroupStatuses: null
  },
  getters: {
    getShowGroupLearningModal: state => state.ShowGroupLearningModal,
    getShowMediaUploader: state => state.ShowMediaUploader,
    getEventsList: state => state.EventsList,
    getGroupeInfo: state => state.GroupeInfo,
    getGroupStatuses: state => state.GroupStatuses
  },
  mutations: {
    SetShowGroupLearningModal (state, val) {
      state.ShowGroupLearningModal = val
    },
    SetShowMediaUploader (state, val) {
      state.ShowMediaUploader = val
    },
    SetEventsList (state, val) {
      state.EventsList = val
    },
    SetGroupeInfo (state, val) {
      state.GroupeInfo = val
    },
    SetGroupStatuses (state, val) {
      state.GroupStatuses = val
    }
  },
  actions: {
    setAllGroupe ({ state, commit, dispatch }) {
      Api.getApi({
        url: '/api/EduGroup/GetAllEduGroups'
      }, 'education')
        .then((data) => {
          console.log('data: ', data)
          commit('SetEventsList', data.Data)
        })
    },
    setDeleteItemGroupe ({ state, commit, dispatch }, id) {
      Api.deleteApi({
        url: `/api/EduGroup/DeleteEduGroup/${id}`
      }, 'education')
        .then((data) => {
          console.log('data: ', data)
          dispatch('setAllGroupe')
        })
    },
    setCreateItemGroupe ({ state, commit, dispatch }, val) {
      Api.postApi({
        url: '/api/EduGroup/CreateEduGroup',
        payload: val
      }, 'education')
        .then((data) => {
          console.log('data: ', data)
        })
    },
    setGetItemGroupe ({ state, commit, dispatch }, val) {
      Api.getApi({
        url: `/api/EduGroup/GetEduGroupById/${val}`
      }, 'education')
        .then((data) => {
          commit('SetGroupeInfo', data.Data)
        })
    },
    setIUpdateItemGroupe ({ state, commit, dispatch }, val) {
      console.log('val: ', val)
      Api.putApi({
        url: '/api/EduGroup/UpdateEduGroup',
        payload: val
      }, 'education')
        .then((data) => {
          commit('SetGroupeInfo', data.Data)
        })
    },
    setGroupStatuses ({ state, commit, dispatch }) {
      Api.getApi({
        url: '/api/GroupStatus/GetAllGroupStatuses'
      }, 'education')
        .then((data) => {
          commit('SetGroupStatuses', data.Data)
        })
    }
  }
}
